import { useContext } from "react"
import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"
import { VerticalSplit } from "@mui/icons-material"
import { IconButton } from "@mui/material"
import { MetricsTemplateShape } from "components/custom-metrics-selector/helpers/prop-types"
import { useHasResourcePermission } from "hooks/permissions"
import { PERMISSION_LEVELS } from "helpers/permissions"
import { useMetricsSelectorAnalytics } from "components/custom-metrics-selector/hooks/use-metrics-selector-analytics"

export default function CustomHeader({ templateMetadata, context }) {
  const assetViewContext = useContext(context)
  const { setShowMetricsSelector, showMetricsSelector } = assetViewContext
  const analytics = useMetricsSelectorAnalytics(assetViewContext)

  const canEditColumns = useHasResourcePermission(templateMetadata, PERMISSION_LEVELS.WRITE)
  if (templateMetadata && !canEditColumns) {
    return null
  }

  const handleMetricsSelectorClick = () => {
    if (!showMetricsSelector) {
      analytics?.trackOpened?.(templateMetadata)
    }
    setShowMetricsSelector(!showMetricsSelector)
  }

  // [TODO] find better solution for alignment
  return <OPTooltip title="Edit Columns">
    <IconButton className="column-button" onClick={handleMetricsSelectorClick}><VerticalSplit /></IconButton>
  </OPTooltip>
}

CustomHeader.propTypes = {
  templateMetadata: MetricsTemplateShape,
  context: PropTypes.object.isRequired,
}
